//Developed by MayurD
function onReady(callback) {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
}

const formatINR = amount => `Rs.${amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const formatINR2 = amount => `Rs.${amount.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;

function updateSavings(card, compare, current) {
  const savingEl = card.querySelector('.saving-box span');
  const savings = compare > current ? compare - current : 0;
  if (savingEl) {
    savingEl.textContent = formatINR2(savings);
    savingEl.style.color = savings > 0 ? '#FFD700' : 'white';
    savingEl.style.fontWeight = savings > 0 ? 'bold' : 'normal';
  }
}

function updatePercent(card, compare, current) {
  const percentEl = card.querySelector('.saving-percent-label');
  const percent = compare > current ? Math.round(((compare - current) / compare) * 100) : 0;
  if (percentEl) percentEl.textContent = `Save ${percent}%`;
}

function createSoldOutButton() {
  const btn = document.createElement('button');
  btn.className = 'sold-out-btn';
  btn.textContent = 'Sold Out';
  btn.disabled = true;
  return btn;
}

function createQtySelector(qty, variantId) {
  const wrapper = document.createElement('div');
  wrapper.className = 'qty-selector';

  const minus = document.createElement('button');
  minus.textContent = '–';
  minus.className = 'qty-minus';

  const display = document.createElement('span');
  display.textContent = qty;
  display.className = 'qty-display';

  const plus = document.createElement('button');
  plus.textContent = '+';
  plus.className = 'qty-plus';

  wrapper.appendChild(minus);
  wrapper.appendChild(display);
  wrapper.appendChild(plus);

  // Animated update
  const animateQty = (newQty) => {
    display.textContent = newQty;
    display.classList.remove('flash'); // reset
    void display.offsetWidth; // reflow hack to re-trigger animation
    display.classList.add('flash');
  };

  // Store variant ID on the wrapper for event delegation
  wrapper.dataset.variantId = variantId;

  // Store the animate function on the wrapper for event delegation
  wrapper.animateQty = animateQty;

  return wrapper;
}

function updateCartQty(variantId, newQty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: newQty })
  })
    .then(res => res.json())
    .then(() => {
      updateCartCount();
      refreshMiniCart();
      initCards(); // Re-render cards with updated state
    });
}

async function handleAddToCart(e) {
  const btn = e.target;
  const variantId = btn.dataset.variantId;

  if (!variantId || btn.disabled) return;

  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = 'Adding...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });

    if (!res.ok) throw new Error('Cart Add Failed');

    updateCartCount();

    // Just re-render cards (don’t open mini cart)
    // initCards();

    // Explicitly update Shopflo button or drawer logic (no mini-cart trigger here)
    // handleFloCartBtn();
    initCards();

  } catch (err) {
    console.error('Add to Cart Error:', err);
  } finally {
    btn.disabled = false;
    btn.textContent = originalText;
  }
}






function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const itemCount = cart.item_count;

      // 🧠 Desktop Icon Bubble
      const desktopIcon = document.getElementById('flo-cart-icon');
      if (desktopIcon) {
        let countSpan = desktopIcon.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        const bubble = desktopIcon.querySelector('.flo-cart-icon-bubble');

        if (itemCount > 0) {
          if (!countSpan) {
            const newBubble = document.createElement('span');
            newBubble.className = 'cart-count-bubble';
            countSpan = document.createElement('span');
            countSpan.setAttribute('aria-hidden', 'true');
            newBubble.appendChild(countSpan);
            desktopIcon.appendChild(newBubble);
          }
          countSpan.innerText = itemCount;
          if (bubble) bubble.style.display = 'inline-flex';
        } else {
          if (bubble) bubble.style.display = 'none';
        }
      }

      // 🧠 Mobile Icon Bubble
      const mobileIcon = document.getElementById('mobile-cart-icon-bubble');
      if (mobileIcon) {
        let mobileCountSpan = mobileIcon.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        const bubble = mobileIcon.querySelector('.cart-count-bubble');

        if (itemCount > 0) {
          if (!mobileCountSpan) {
            const newBubble = document.createElement('span');
            newBubble.className = 'cart-count-bubble';

            mobileCountSpan = document.createElement('span');
            mobileCountSpan.setAttribute('aria-hidden', 'true');
            newBubble.appendChild(mobileCountSpan);

            const hiddenSpan = document.createElement('span');
            hiddenSpan.className = 'visually-hidden';
            newBubble.appendChild(hiddenSpan);

            mobileIcon.appendChild(newBubble);
          }
          mobileCountSpan.innerText = itemCount;

          const visuallyHidden = mobileIcon.querySelector('.cart-count-bubble .visually-hidden');
          if (visuallyHidden) {
            visuallyHidden.innerText = `${itemCount} item${itemCount !== 1 ? 's' : ''}`;
          }

          if (bubble) bubble.style.display = 'inline-flex';
        } else {
          if (bubble) bubble.style.display = 'none';
        }
      }

      // 🔥 Mobile Bottom Bar Update
      const mobileCartBar = document.querySelector('.mobile-cart-bar');
      const mobileCartBarCount = document.querySelector('.mobile-cart-bar-count');

      if (mobileCartBar && mobileCartBarCount) {
        if (itemCount > 0) {
          mobileCartBarCount.textContent = `${itemCount} item${itemCount > 1 ? 's' : ''} added to cart`;
          mobileCartBar.style.display = 'flex';
          mobileCartBar.style.transform = 'translateY(0%)';
        } else {
          mobileCartBar.style.transform = 'translateY(100%)';
          setTimeout(() => {
            mobileCartBar.style.display = 'none';
          }, 300);
        }
      }
    })
    .catch(err => console.error('Cart Count Error:', err));
}


function refreshMiniCart() {
  const miniCart = document.getElementById('mini-cart');
  if (!miniCart) return;

  fetch(miniCart.dataset.url)
    .then(res => res.text())
    .then(html => {
      miniCart.innerHTML = new DOMParser().parseFromString(html, 'text/html').body.innerHTML;
      initCards();
    });
}

function initCards() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartItems = cart.items.reduce((map, item) => {
        map[item.variant_id] = item.quantity;
        return map;
      }, {});

      // Always use document to ensure we get all cards, not just context
      document.querySelectorAll('.product-card-final').forEach(card => {
        const select = card.querySelector('.variant-selector');
        if (!select) return;

        const selected = select.options[select.selectedIndex];
        const variantId = selected.value;
        const price = parseFloat(selected.dataset.price);
        const compare = parseFloat(selected.dataset.comparePrice);

        card.querySelector('.sale-price').textContent = formatINR(price);
        const compareEl = card.querySelector('.compare-price');
        if (compare > price) {
          if (!compareEl) {
            card.querySelector('.price-container').insertAdjacentHTML('beforeend', `<div class="compare-price">${formatINR(compare)}</div>`);
          } else {
            compareEl.textContent = formatINR(compare);
          }
        } else if (compareEl) {
          compareEl.remove();
        }

        updateSavings(card, compare, price);
        updatePercent(card, compare, price);

        const container = card.querySelector('.price-row');
        const existing = container.querySelector('.add-to-cart-btn, .qty-selector, .sold-out-btn');
        const existingVariantId = existing?.dataset.variantId;
        const shouldShowSoldOut = selected.disabled;
        const shouldShowQuantity = !shouldShowSoldOut && Boolean(cartItems[variantId]);
        const shouldShowAdd = !shouldShowSoldOut && !shouldShowQuantity;

        // A matching control type can still belong to the previously selected variant.
        const needsUpdate = !existing ||
          (shouldShowSoldOut && !existing.classList.contains('sold-out-btn')) ||
          (shouldShowQuantity && (
            !existing.classList.contains('qty-selector') || existingVariantId !== variantId
          )) ||
          (shouldShowAdd && (
            !existing.classList.contains('add-to-cart-btn') || existingVariantId !== variantId
          ));

        if (needsUpdate && existing) {
          existing.remove();
        }

        if (needsUpdate) {
          if (shouldShowSoldOut) {
            container.appendChild(createSoldOutButton());
          } else if (shouldShowQuantity) {
            container.appendChild(createQtySelector(cartItems[variantId], variantId));
          } else {
            const btn = document.createElement('button');
            btn.className = 'add-to-cart-btn';
            btn.dataset.variantId = variantId;
            btn.textContent = 'Add';
            container.appendChild(btn);
          }
        } else if (existing.classList.contains('qty-selector')) {
          const qtyDisplay = existing.querySelector('.qty-display');
          if (qtyDisplay) {
            qtyDisplay.textContent = cartItems[variantId];
          }
        }
      });
    });
}

function watchDynamicSections() {
  let debounceTimeout;
  const observer = new MutationObserver(mutations => {
    let shouldUpdate = false;

    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if ((node.querySelectorAll && node.querySelector('.product-card-final')) ||
            node.classList?.contains('product-card-final')) {
            shouldUpdate = true;
          }
        }
      });
    });

    if (shouldUpdate) {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        initCards();
      }, 50);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Event delegation - set up once when script loads
document.addEventListener('change', (e) => {
  if (e.target.classList.contains('variant-selector')) {
    const card = e.target.closest('.product-card-final');
    const addButton = card?.querySelector('.add-to-cart-btn');

    // Keep the actionable ID in sync immediately; initCards waits on /cart.js.
    if (addButton) {
      addButton.dataset.variantId = e.target.value;
    }

    initCards();
  }
});

document.addEventListener('click', (e) => {
  if (e.target.classList.contains('add-to-cart-btn')) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const select = e.target.closest('.product-card-final')?.querySelector('.variant-selector');
    if (select) {
      // The dropdown is the source of truth, even if an async card refresh is pending.
      e.target.dataset.variantId = select.value;
    }

    handleAddToCart(e);
    return false;
  }

  // Quantity selector buttons
  if (e.target.classList.contains('qty-plus')) {
    const wrapper = e.target.closest('.qty-selector');
    if (!wrapper) return;

    const variantId = wrapper.dataset.variantId;
    const display = wrapper.querySelector('.qty-display');
    const currentQty = parseInt(display.textContent);
    const newQty = currentQty + 1;

    updateCartQty(variantId, newQty);
    if (wrapper.animateQty) {
      wrapper.animateQty(newQty);
    }
  }

  if (e.target.classList.contains('qty-minus')) {
    const wrapper = e.target.closest('.qty-selector');
    if (!wrapper) return;

    const variantId = wrapper.dataset.variantId;
    const display = wrapper.querySelector('.qty-display');
    const currentQty = parseInt(display.textContent);
    const newQty = currentQty - 1;

    if (newQty < 1) {
      updateCartQty(variantId, 0);
    } else {
      updateCartQty(variantId, newQty);
      if (wrapper.animateQty) {
        wrapper.animateQty(newQty);
      }
    }
  }
});

onReady(() => {
  initCards();
  watchDynamicSections();
});
